import { render, staticRenderFns } from "./file-upload-component.vue?vue&type=template&id=9c579d78&scoped=true"
import script from "./file-upload-component.ts?vue&type=script&lang=ts&external"
export * from "./file-upload-component.ts?vue&type=script&lang=ts&external"
import style0 from "./file-upload-component.scss?vue&type=style&index=0&id=9c579d78&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c579d78",
  null
  
)

export default component.exports